import React from 'react';
import Header from '../components/Header';
import Navigation from '../components/Navigation';
import Footer from '../components/Footer';

function GoverningCouncil() {
  return (
    <div id="top">
      <div id="wrapper">
        <Header />
        <div id="navig_inside">
          <Navigation />
        </div>
        <div id="banner"></div>
        <div id="inside_page" className="bodyText">
          <div id="page1">
            <span className="bodyText">
              <p className="welcome_heading">"Sri Krishna Shikshana Prathisthana Trust, Governing Council and <strong>Faculty Details</strong>"</p>
              <div id="sec_nav" className="sec_nav_text"><a className="inlinks" href="#a">Trust Members</a>&nbsp;&nbsp;&nbsp;|&nbsp;&nbsp;&nbsp;<a className="inlinks" href="#b">Governing Council&nbsp;&nbsp;&nbsp;</a>|&nbsp;&nbsp;&nbsp;<a className="inlinks" href="#b">Faculty</a><br />
              </div>
              <p><strong><a name="a" id="a"></a><br />
                Sri Krishna Shikshana Prathisthana Trust</strong> is promoted by Sri Krishnapura Mutt, Car Street, Udupi.<br />
                Presently, the Trust is having the following members:</p>
            </span>
            <div style={{ textAlign: 'center' }}>
              <table width="600" border="0" cellPadding="0" cellSpacing="0" style={{ border: '1px solid #eeeeee' }}>
                <tbody>
                  <tr>
                    <td width="10%" height="35" style={{ textAlign: 'center' }} bgcolor="#5F97CF"><strong>Sl. No.</strong></td>
                    <td width="67%" height="35" bgcolor="#5F97CF"><p style={{ textAlign: 'center' }}><strong>Name</strong></p></td>
                    <td width="20%" height="35" bgcolor="#5F97CF"><p style={{ textAlign: 'center' }}><strong>Designation</strong></p></td>
                  </tr>
                  <tr bgcolor="#F5F5F5">
                    <td height="35"><p style={{ textAlign: 'center' }}>1</p></td>
                    <td height="35"><p style={{ textAlign: 'center' }}>Sri Sri Vidyasagara Theertha Swamiji<br />
                      Mathadhipathi, Sri Krishnapura Mutt, Car Street, Udupi</p></td>
                    <td height="35"><p style={{ textAlign: 'center' }}>President</p></td>
                  </tr>
                  <tr bgcolor="#F5F5F5">
                    <td height="35"><p style={{ textAlign: 'center' }}>2</p></td>
                    <td height="35"><p style={{ textAlign: 'center' }}>Sri Shreesha Acharya<br />
                      Ex-Principal, M. G. M. College, Udupi</p></td>
                    <td height="35"><p style={{ textAlign: 'center' }}>Secretary</p></td>
                  </tr>
                  <tr bgcolor="#F5F5F5">
                    <td height="35"><p style={{ textAlign: 'center' }}>3</p></td>
                    <td height="35"><p style={{ textAlign: 'center' }}>Sri B. Ramananda Rao, B.E, . <br />
                      Executive Engineer, MESCOM</p></td>
                    <td height="35"><p style={{ textAlign: 'center' }}>Member</p></td>
                  </tr>
                  <tr bgcolor="#F5F5F5">
                    <td width="10%" height="35"><p style={{ textAlign: 'center' }}>4</p></td>
                    <td width="67%" height="35"><p style={{ textAlign: 'center' }}>Sri U. K. Raghavendra Rao, B.E. <br />
                      Civil Engineer &amp; Valuer, Udupi</p></td>
                    <td width="20%" height="35"><p style={{ textAlign: 'center' }}>Member</p></td>
                  </tr>
                  <tr bgcolor="#F5F5F5">
                    <td height="35"><p style={{ textAlign: 'center' }}>5</p></td>
                    <td height="35"><p style={{ textAlign: 'center' }}>Sri H. K. V. Rao, B.Tech, M.Tech <br />
                      Retired Professor, M. I. T., Manipal</p></td>
                    <td height="35"><p style={{ textAlign: 'center' }}>Member</p></td>
                  </tr>
                  <tr bgcolor="#F5F5F5">
                    <td height="35"><p style={{ textAlign: 'center' }}>6</p></td>
                    <td height="35"><p style={{ textAlign: 'center' }}>Sri U. Ramesh Rao, B.E. <br />
                      Civil Engineer &amp; Vastu Consultant, Udupi</p></td>
                    <td height="35"><p style={{ textAlign: 'center' }}>Member</p></td>
                  </tr>
                  <tr bgcolor="#F5F5F5">
                    <td height="35"><p style={{ textAlign: 'center' }}>7</p></td>
                    <td height="35"><p style={{ textAlign: 'center' }}>Dr. Mohandas Bhat S, B.E., M.E., Ph.D.,<br />
                      Retired Professor, M S Ramaiah Institute of Technology, Bengaluru</p></td>
                    <td height="35"><p style={{ textAlign: 'center' }}>Member</p></td>
                  </tr>
                </tbody>
              </table>
            </div>
            <p>&nbsp;</p>
          </div>
        </div>
        <Footer />
      </div>
    </div>
  );
}

export default GoverningCouncil;
